import { render, staticRenderFns } from "./NodeSingularityContentEditable.vue?vue&type=template&id=9d70e4c4&"
import script from "./NodeSingularityContentEditable.vue?vue&type=script&lang=ts&"
export * from "./NodeSingularityContentEditable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports